import React from "react";
import "../../styles/PaintWindow.css";
import closeButton from "../../assets/images/close.png";

const PaintWindow = ({ onClose }) => {
    return (
        <div className="paint-window">
            <div className="paint-header">
                <span>Paint Akalex Edition - (Slide with two fingers to move the canva)</span>
                <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer" }}>
                <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
                </button>
            </div>
            <div className="paint-content">
                <iframe
                    title="Paint Akalex Edition"
                    width="100%"
                    height="100%"
                    src="https://jspaint.app"
                />
            </div>
        </div>
    );
};

export default PaintWindow;